export function LegalPage({ eyebrow, title, updated, sections }) {
  return (
    <div data-testid="legal-page" className="bg-[#FAFAF8]">
      <div className="max-w-2xl mx-auto px-6 md:px-10 pt-16 md:pt-20 pb-20 md:pb-28">
        <p className="text-xs tracking-[0.22em] uppercase text-[#159E9A] mb-4">
          {eyebrow}
        </p>
        <h1
          data-testid="legal-page-title"
          className="font-display text-4xl md:text-5xl leading-[1.1] tracking-tight text-[#1C1917] mb-3"
        >
          {title}
        </h1>
        <p className="text-sm text-[#57534E] mb-12">Last updated: {updated}</p>

        <div className="space-y-10">
          {sections.map((section, i) => (
            <div key={i} data-testid={`legal-section-${i}`}>
              <h2 className="font-display text-2xl text-[#1C1917] mb-3">
                {section.heading}
              </h2>
              <div className="space-y-4 text-base leading-relaxed text-[#3F3B37]">
                {section.body.map((para, j) => (
                  <p key={j}>{para}</p>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
